<template>
  <section id="head">
    <div class="container col-xl-12 col-xxl-12 px-4 py-5 bgTop posRel">
      <div class="row align-items-center g-lg-5 py-5">

        <div class=" bgWight formStyle posRel uploadDocumenti">
          <div class="headForm">
            <div class="row g-3 ">
              <div class="col-md-3 col-6 order-md-1 float-left">
                <img class="logo" src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsoalvolo-logo.webp">
              </div>
              <div class="col-md-3 col-6 order-md-3 float-right imgTitoloDocumento">
                <img src="https://www.rimborsoalvolo.it/cresources/outform/images/dimezzaTempi_small.png">
              </div>
              <div class="col-md-6 col-12 order-md-2">
                <p class="titoloDocumenti"><b>Riduci i tempi di elaborazione 2</b>/3</p>
              </div>

            </div>

          </div>
          <div class="p-4 p-md-4 ">
            <div class="row g-2">

              <div class="mb-3">
                <div>Carta di identità passeggero</div>
                <div class="input-group mb-3">

                  <div class="u-file-input-wrapper">
                    <file-upload
                        fileuploadid="fupcontrol1"
                        :ticketref="s_ticketref"
                        :psgref="s_psgref"
                        filetype="7"
                        @uploadcomplete="uploadCompletato(1)"
                        :label='this.$i18n.t("message.fup_caricafile")'
                        :showimage="false"
                    ></file-upload>
                  </div>

                </div>
                <div class="error" v-if="imbarcoobbligatorio && !file1complete && showerrors">Caricare un documento</div>
                <div class="txtNote" v-if="!file1complete" >{{ $t('message.dimensione_max_10mb') }}</div>

              </div>

            </div>

            <div class="row g-2">

              <div class="mb-3">
                <div>Carta d'imbarco</div>
                <div class="input-group mb-3">

                  <div class="u-file-input-wrapper">
                    <file-upload
                        fileuploadid="fupcontrol2"
                        :ticketref="s_ticketref"
                        :psgref="s_psgref"
                        filetype="3"
                        @uploadcomplete="uploadCompletato(2)"
                        :label='this.$i18n.t("message.fup_caricafile")'
                        :showimage="false"
                    ></file-upload>
                  </div>

                </div>
                <div class="error" v-if="imbarcoobbligatorio && !file2complete && showerrors">Caricare la carta d'imbarco</div>
                <div class="txtNote" v-if="!file2complete">{{ $t('message.dimensione_max_10mb') }}</div>

              </div>

            </div>


            <div class="row g-2" v-if="s_tipoproblema == 3">

              <div class="mb-3">
                <div>PIR</div>
                <div class="input-group mb-3">

                  <div class="u-file-input-wrapper">
                    <file-upload
                        fileuploadid="fupcontrol3"
                        :ticketref="s_ticketref"
                        :psgref="s_psgref"
                        filetype="19"
                        @uploadcomplete="uploadCompletato(3)"
                        :label='this.$i18n.t("message.fup_caricafile")'
                        :showimage="false"
                    ></file-upload>
                  </div>

                </div>
                <div class="error"></div>
                <div class="txtNote" v-if="!file3complete">{{ $t('message.dimensione_max_10mb') }}</div>

              </div>

            </div>
            <div class="row g-3 ">
              <div class="col-md-4 order-md-3">
                <span><img class="fixBack pointerBtn" src="https://www.rimborsoalvolo.it/cresources/outform/images/indietro.png" @click="precedente"></span>
                <button type="submit" class="btn styleBtn mb-3 float-end" @click="submit()">Avanti ></button>
              </div>
              <div class="col-md-4 order-md-1">

              </div>
              <div class="col-md-4 order-md-2">

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
  <trust-pilot></trust-pilot>
  <conteggio-reclami></conteggio-reclami>
  <recensioni-f-b></recensioni-f-b>
  <sezione-a-p-r-a></sezione-a-p-r-a>
  <page-footer></page-footer>
</template>

<script>
import FileUpload from "@/components/FileUpload";
import {computed} from "vue";
import {useStore} from "vuex";
import Datepicker from '@vuepic/vue-datepicker';
import useVuelidate from "@vuelidate/core";
import {helpers} from "@vuelidate/validators";
import moment from "moment";
import {submitDataComunicazione} from "@/lib/submit";
import ConteggioReclami from "@/components/ConteggioReclami";
import TrustPilot from "@/components/TrustPilot";
import RecensioniFB from "@/components/RecensioniFB";
import SezioneAPRA from "@/components/SezioneAPRA";
import PageFooter from "@/components/PageFooter";
const isDate = helpers.withParams(
    {type:'isDate'},
    (value)=>{ try{let tdate = moment(value); return tdate.isValid()}catch(e){ return false;}}
);

export default {
  name: "RichiedenteStep7",
  setup(){

    const store = useStore();
    const s_ticketref = computed(()=>store.state.compilazione.tktref);
    const s_ticketid = computed(()=>store.state.compilazione.ticketid);
    const s_psgref = computed(()=>store.state.passeggeri.nextpsgref);
    const s_tipoproblema = computed(()=>store.state.volo.tipoproblema);
    const s_nextpsgref = computed( ()=>store.state.passeggeri.nextpsgref);
    const s_passeggeri = computed(()=>store.state.passeggeri.passeggeri);
    const s_step7_inviato = computed( ()=>store.state.gtmstate.step7inviato);
    return {
      s_ticketid,
      s_ticketref,
      s_psgref,
      s_tipoproblema,
      s_nextpsgref,
      s_passeggeri,
      s_step7_inviato,
      setStep7Inviato: function(){
        store.dispatch('gtmstate/commitSetStatoInvio7',true);
      },
      v$: useVuelidate(),
    }
  },
  data(){
    return {
      file1complete: false,
      file2complete: false,
      file3complete: false,
      showerrors: false,
      imbarcoobbligatorio: false,
    }
  },
  components:{
    FileUpload,
    Datepicker,
    PageFooter,
    SezioneAPRA,
    RecensioniFB,
    TrustPilot,
    ConteggioReclami,
  },
  computed:{
    fileUploadProperties:function(){
      return {
        "ticketref":this.s_ticketref,
        "psgref":this.s_psgref,
      }
    }
  },
  validations(){
    return {

    }
  },
  mounted(){
    if(this.s_ticketref === null){
      this.$router.push({name:'step1'});
    }else{
      // eslint-disable-next-line
      if(this.s_nextpsgref !== null) {
        let pvalue = this.s_nextpsgref;
        let pass = this.s_passeggeri.find(function (obj) {
          return obj.id == pvalue;
        });

        if(pass !== null){
          this.imbarcoobbligatorio = pass.estero;
        }
      }

      window.scrollTo(0,0);
      if(!this.s_step7_inviato) {
        this.setStep7Inviato();
        this.$gtm.trackEvent({
              event: 'step_visitato',
              value: 7,
            }
        );
      }


    }
    window.scrollTo(0,0);
  },
  methods:{
    uploadCompletato(file){
      if(file === 1 ) this.file1complete = true;
      if(file === 2 ) this.file2complete = true;
      if(file === 3 ) this.file3complete = true;
    },
    precedente(){
      this.$router.push({name:'step6'})
    },
    async submit(){
     /* const valid = await this.v$.$validate();*/
      if(this.imbarcoobbligatorio &&  ( !this.file2complete || !this.file1complete ) ){
        this.showerrors = true;
        return;
      }
      let me = this;
     /* if(this.datacomunicazione !== null && moment(this.datacomunicazione).isValid()) {
        submitDataComunicazione(moment(this.datacomunicazione).format('DD/MM/YYYY'), this.s_ticketref).then((response) => {
          if (response.data.STATUS === "OK") {
            me.$router.push({name:'step8'});
          }else{
            me.route.push({name:'error'})
          }
        });
      }else */me.$router.push({name:'step8'});

    }
  }
}
</script>

<style scoped>
.pointerBtn {
  cursor: pointer;
}

</style>